<template>
  <div class="account-menu-container">
    <div @click.prevent="handleChange(menu.key)" v-for="menu in menus" :key="menu.key" :id="menu.id" class="menu-item">
      <profile-icon v-if="menu.id === 'profil'" :isActive="menuActive === menu.key" />
      <setting-icon v-if="menu.id === 'pengaturan-akun'" :isActive="menuActive === menu.key" />
      <file-icon v-if="menu.id === 'riwayat-pembelian'" :isActive="menuActive === menu.key" />
      <p :class="menuActive === menu.key ? 'th-text-primary th-font-weight-bold' : ''">{{menu.name}}</p>
    </div>
  </div>
</template>

<script>

const ProfileIcon = () => import('@/components/Icon/Person')
const SettingIcon = () => import('@/components/Icon/Setting')
const FileIcon = () => import('@/components/Icon/File')
export default {
  components: {
    ProfileIcon,
    SettingIcon,
    FileIcon,
  },
  props: {
    menus: {
      type: Array,
      required: true,
    },
    menuActive: {
      type: Number,
      required: true,
    },
  },
  methods: {
    handleChange(key) {
      this.$emit('menu-change', key)
    },
  },
}
</script>

<style lang="scss">
.account-menu-container {
  display: flex;
  flex-direction: column;

  .menu-item {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;
    margin-bottom: 2px;
  }
}
</style>
